import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useInviteService } from '../services/invite';
import { Invite } from '../services/invite/types';
import InvitePageMessage from './InvitePageMessage';
import InviteForm from './InviteForm';
import { TheezyIcon } from '../icons';
import '../support/styles.css';
import './styles.css';

const InvitePage = () => {
    const { inviteId } = useParams();
    const [invite, setInvite] = useState<Invite>();
    const [inviteNotFound, setInviteNotFound] = useState<boolean>(false);
    const [inviteAccepted, setInviteAccepted] = useState<boolean>(false);
    const inviteService = useInviteService();
    const onSubmissionSuccess = () => {
        setInviteAccepted(true);
    };
    useEffect(() => {
        if (inviteId) {
            inviteService.getInvite(inviteId)
                .then((invite) => {
                    setInvite(invite);
                })
                .catch(() => {
                    setInviteNotFound(true);
                });
        }
    }, []);
    return (
        <div className="invite-page">
            <div className="invite-page-logo">
                <TheezyIcon light/>
            </div>
            <div className="invite-page-content">
                <div className="invite-page-card">
                    <div className="survey-view">
                        {inviteAccepted ? (
                            <InvitePageMessage
                                title="Invite Accepted"
                                message="You have successfully accepted the invite."
                                link={{ title: 'Login to your account', href: '/' }}
                            />
                        ) : inviteNotFound ? (
                            <InvitePageMessage
                                title="Invite Not Found"
                                message="Please check the link you received and try again."
                            />
                        ) : !invite ? (
                            <InvitePageMessage title="Loading..." />
                        ) : (
                            <InviteForm onSubmissionSuccess={onSubmissionSuccess} id={invite._id}/>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvitePage;
